<template>
  <div
    v-if="isOnAir || isPlannedToAir"
    class="on-air-container"
    :title="showTooltip ? tooltip : ''"
  >
    <div
      v-if="isOnlyActive"
      class="on-air-circle green accent-4 mx-1 my-1"
    />
    <div
      v-if="isOnlyPlanned"
      class="on-air-circle orange accent-2 mx-1 my-1"
    />
    <div
      v-if="isBothActiveAndPlanned"
      class="on-air-circle both-active-and-planned mx-1 my"
    />
  </div>
</template>

<script>
export default {
  props: {
    isOnAir: {
      type: Boolean,
      default: null,
    },
    isPlannedToAir: {
      type: Boolean,
      default: null,
    },
    showTooltip: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isOnlyActive() {
      return this.isOnAir && !this.isPlannedToAir;
    },
    isOnlyPlanned() {
      return !this.isOnAir && this.isPlannedToAir;
    },
    isBothActiveAndPlanned() {
      return this.isOnAir && this.isPlannedToAir;
    },
    tooltip() {
      if (this.isOnlyActive) {
        return this.$t('onAirContentActive');
      } else if (this.isOnlyPlanned) {
        return this.$t('onAirContentPlanned');
      } else if (this.isBothActiveAndPlanned) {
        return this.$t('onAirContentActiveAndPlanned');
      }
      return '';
    },
  },
};
</script>

<style scoped>
.on-air-container {
  min-width: 24px; /* Match v-icon so they line up. */
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.on-air-circle {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  z-index: 1;
}

/* Colors match 'orange accent-2' and 'green accent-4'
   See: https://vuetifyjs.com/en/style/colors */
.on-air-circle.both-active-and-planned {
  background: linear-gradient(
    -45deg,
    #ffab40,
    #ffab40 49%,
    white 49%,
    white 51%,
    #00c853 51%
  );
}
</style>



// WEBPACK FOOTER //
// src/components/OnAirIndicator.vue